export default __webpack_public_path__ + "static/media/ant-circle.2f650e37.png";